export default class UrlHelper {

    static getUrlByParams(url, params, defaultParams = {}) {
        let paramsPrefix = url.indexOf('?') === -1 ? '?' : '&';
        let paramsString = UrlHelper.getQueryStringByParams(params, defaultParams);
        return `${url}` + (paramsString !== '' ? `${paramsPrefix}${paramsString}` : '');
    }

    static getQueryStringByParams(params, defaultParams = {}) {
        let searchableParams = this.getSearchableParams(params, defaultParams);
        return Object.keys(searchableParams).map(key => `${key}=${encodeURIComponent(searchableParams[key])}`).join('&')
    }

    static getSearchableParams(params, defaultParams = {}) {
        let result = {};
        for (let i in params) {
            if (!(i in defaultParams) || (params[i] !== defaultParams[i])) {
                result[i] = params[i];
            }
        }
        return result;
    }

    static getSearchFromLocation(location) {
        return this.getParamsFromQueryString(location.search.substring(1))
    }

    static getParamsFromQueryString(queryString) {
        let str = queryString.replace(/\/$/, '') || '';
        let obj = {};
        let key;
        let value;

        str.split('&').forEach((keyValue) => {
            if (keyValue) {
                value = keyValue.split('=');
                key = decodeURIComponent(value[0]);
                obj[key] = value[1] ? decodeURIComponent(value[1]) : '';
            }
        });
        return obj;
    }

    static getPathWithQueryString(location, exceptParams = []) {
        let baseUrl = location.pathname;
        let searchObject = this.getSearchFromLocation(location);
        let paramsKeys = Object.keys(searchObject).filter((key) => exceptParams.indexOf(key) === -1);
        let paramsObject = paramsKeys.reduce((result, key) => {
            result[key] = searchObject[key];
            return result;
        }, {});
        return this.getUrlByParams(baseUrl, paramsObject);
    }
}



// WEBPACK FOOTER //
// ./app/general/js/url-helper.js